"use client";

import { defaultLocale, type Locale } from "@/lib/i18n";
import AgentUseCasePage from "./AgentUseCasePage";
import { supportTriage } from "@/content/agent-use-cases/support-triage";

export default function SupportTriageUseCase({
  locale = defaultLocale,
}: {
  locale?: Locale;
}) {
  return <AgentUseCasePage useCase={supportTriage} locale={locale} />;
}
